import { render, staticRenderFns } from "./SuperadminExternalSoftware.vue?vue&type=template&id=5dfbee25&scoped=true&"
import script from "./SuperadminExternalSoftware.vue?vue&type=script&lang=js&"
export * from "./SuperadminExternalSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfbee25",
  null
  
)

export default component.exports